import { useParams, Navigate, Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyBanner } from "@/components/StickyBanner";
import { SEO } from "@/components/SEO";
import { ChineseTestimonials } from "@/components/ChineseTestimonials";
import { ChineseFinalCTA } from "@/components/ChineseFinalCTA";
import { LocationContext, REGIONS } from "@/lib/locations";
import { getLocalContent } from "@/lib/city-content";
import { Guarantee } from "@/components/Guarantee";
import { Button } from "@/components/ui/button";
import { Zap } from "lucide-react";

const BOOKING_URL = "/book";

const ChineseDeepCleanPage = () => {
  const { citySlug } = useParams<{ citySlug: string }>();
  const citySlugNorm = (citySlug || "sacramento").toLowerCase().replace(/\s+/g, "-");
  
  let foundRegionSlug = "sacramento-area";
  let cityName = "Sacramento";
  for (const [rSlug, region] of Object.entries(REGIONS)) {
    const city = region.cities.find(c => c.toLowerCase().replace(/\s+/g, "-") === citySlugNorm);
    if (city) {
      foundRegionSlug = rSlug;
      cityName = city;
      break;
    }
  }

  return (
    <LocationContext.Provider value={{ slug: citySlugNorm, name: cityName, type: "city", regionSlug: foundRegionSlug as any }}>
      <SEO
        title={`${cityName}深度清洁服务 | Uplevel Cleaning`}
        description={`${cityName}专业深度清洁服务。彻底清洁每一个角落。`}
        keywords={`深度清洁 ${cityName}, 大扫除 ${cityName}`}
        url={`https://uplevelcleaning.com/zh/limpieza-profunda/${citySlugNorm}`}
        alternateUrl={`https://uplevelcleaning.com/locations/${citySlugNorm}`}
        alternateLang="en-US"
        locationName={cityName}
        regionSlug={foundRegionSlug}
        lang="zh"
      />
      <div className="flex min-h-screen flex-col" lang="zh">
        <StickyBanner />
        <Navbar />
        <main className="flex-1">
          <section className="relative py-20 lg:py-32 bg-background overflow-hidden">
            <div className="container relative z-10 text-center">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-6">
                <span className="text-primary">{cityName}</span> 深度清洁服务
              </h1>
              <p className="text-xl text-muted-foreground mb-4 max-w-2xl mx-auto">
                从上到下的彻底清洁。我们将清洁您家中的每一个角落。
              </p>
              <p className="text-base text-muted-foreground mb-10 max-w-2xl mx-auto border-l-4 border-primary pl-4 text-left">
                {getLocalContent(cityName, foundRegionSlug, 'zh').localIssuesText}
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
                <Button asChild size="lg" className="h-14 px-10 text-lg font-bold bg-primary text-primary-foreground hover:bg-primary/90 btn-pulse">
                  <a href={BOOKING_URL}><Zap className="h-5 w-5 mr-2" />立即预订</a>
                </Button>
              </div>
            </div>
          </section>
          <ChineseTestimonials region="sacramento" />
          <Guarantee />
          <ChineseFinalCTA cityName={cityName} />
        </main>
        <Footer />
      </div>
    </LocationContext.Provider>
  );
};

export default ChineseDeepCleanPage;
